import type {paths} from '../openapi/auth.swagger';
import {axiosInstance} from './axiosInstance';

type ResendOperation = paths['/executor_web/auth/resend']['post'];

export type ResendLoginCodeRequestBody = NonNullable<NonNullable<ResendOperation['requestBody']>['content']['application/json']>;
export interface ResendLoginCodeRequest extends ResendLoginCodeRequestBody {
	token: string;
}
export type ResendLoginCodeResponse = ResendOperation['responses'][200]['content']['application/json'];
export type ResendLoginCodeErrorResponse = ResendOperation['responses'][401]['content']['application/json'];

/** POST `/executor_web/auth/resend` — см. `paths['/executor_web/auth/resend']` в auth swagger */
export function resendLoginCode(request: ResendLoginCodeRequest, signal?: AbortSignal) {
	const {token, ...body} = request;

	return axiosInstance.post<ResendLoginCodeResponse>('auth/resend', body, {
		signal,
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
